import Dataset from '../model/dataset'

import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './datasets-edit.hbs'
import DatasetsDisplayHeader from '../datasets-display-header'
import tabs from '../datasets-tabs.hbs'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import databases from 'scoreboard/components/databases'
import dropdown from 'scoreboard/components/dropdown'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import appDisplay from 'scoreboard/components/app-display'
import DatasetConnectionRow from '../dataset-connection-row'
import fieldRow from './field-row.hbs'
import fieldGroupRow from './field-group-row.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import FieldEquationFormatter from './field-equation-formatter'
import globals from 'scoreboard/components/globals'
import conductor from 'scoreboard/components/conductor'
import Tooltip from 'scoreboard/components/tooltip'
import rangeKeySuffix from './range-key-suffix'
import ChangeTotalDisplay from '../change-total-display'
import dataTypeKey from '../data-type-key'
import PermissionsPanel from './permissions-panel'
import permissions from 'scoreboard/components/permissions'
import noPermission from 'scoreboard/components/no-permission.hbs'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import errorIndicatorTooltip from './error-indicator-tooltip.hbs'
import ErrorView from 'scoreboard/components/error-view'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import deviceType from 'scoreboard/components/device-type'
import FieldGroupForm from './fields/field-group-form'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import FieldAndGroupRenderer from '../field-and-group-renderer'
import DependenciesPreventActionView from 'scoreboard/components/edit/dependencies-prevent-action-view'
import highlight from 'scoreboard/components/highlight'
import datasetPaths from './dataset-paths'
import VisibleLinkedFieldForm from './visible-linked-field-form'
import visibleLinkedFieldRow from './visible-linked-field-row.hbs'
import unwrapModel from 'scoreboard/components/unwrap-model'
import Breadcrumbs from 'scoreboard/components/breadcrumbs'
import scrollContainer from 'scoreboard/components/scroll-container'
import DatasetsTableExpander from './datasets-table-expander'
import CategoriesAndRangesForm from 'scoreboard/datasets/edit/fields/categories-and-ranges-form'
import datasetStatus from 'scoreboard/datasets/not-available/dataset-status'
import BaseDatasetsEditView from './base-datasets-edit-view'
import DatasetFieldErrorView from 'scoreboard/datasets/edit/dataset-field-errors-view'
import FieldWizard from 'scoreboard/datasets/edit/fields/field-wizard'

import GetValidPrimaryKeyFields from './get-valid-primary-key-fields'
const {
    getValidPrimaryKeyDatasetFields,
    getValidPrimaryKeyAutomaticAndDatasetFields,
} = GetValidPrimaryKeyFields

import constants from 'scoreboard/components/constants'
const { DATASET_FIELD_TYPE } = constants
import isGeographicDataType from 'scoreboard/components/is-geographic-data-type'
import { deleteGeographicFieldAllowed, geographicFieldDependencyMessage } from 'scoreboard/datasets/edit/geographic-field-dependencies'
import EditableFieldChecker from './fields/editable-field-checker'
import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT, ROLLUP, DATASET_LINK, CLUSTER } = DataType
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'
import {
	getIntermediateTableColumnFromBasicEquation
} from 'scoreboard/datasets/equations/clean-field-equation-formatter'
import { getIntermediateTableColumnName } from 'scoreboard/datasets/dataset-utils'

var rangesLabel = {
	0: 'datasets.fields.noRanges',
	1: 'datasets.fields.oneRange',
	2: 'datasets.fields.rangesCount'
}

var DatasetsEdit = BaseDatasetsEditView.extend({

	/** @type {Dataset} */
	model: null,

	tagName: 'form',
	className: 'datasets-edit table-hack display-layout',

	events: {
		'click .fields .add': 'addField',
		'click .field-row .edit': 'editField',
		'click .field-row .delete': 'deleteField',
		'click .field-group-row .edit': 'editFieldGroup',
		'click .field-group-row .delete': 'deleteFieldGroup',
		'click .cancel': 'cancel',
		'click .ranges': 'editFieldRange',
		'click .change-total-display': 'changeTotalDisplay',
		'change [name=primaryKey]': 'changePrimaryKey',
		'click .visible-linked-fields .add': 'onAddVisibleLinkedField',
		'click .visible-linked-fields .edit': 'onEditVisibleLinkedField',
		'click .visible-linked-fields .delete': 'onDeleteVisibleLinkedField',
		'change .toggle-all [type=checkbox]': 'toggleAllEditableCheckboxes',
		'change [name=editable]': 'setFieldEditableState',
		'click [name=editable]:disabled + svg': 'onClickDisabledCheckboxTooltip'
	},

	initialize: function(options = {}) {
		this.FormViewClass = FormView.extend({
			validate: this.validate.bind(this)
		})
		BaseDatasetsEditView.prototype.initialize.apply(this, arguments)
		// a record of the model kept up-to-date with our changes
		this.model = options.model.cloneDeep()
		// only deep copy the fields because deep copies can take a long time
		const fieldsCopy = _.cloneDeep(this.model.get('fields'))
		// a record of the model as it is in the database
		this.originalModel = _.clone(options.model)
		this.originalModel.setFields(fieldsCopy)

		this.fieldEquationFormatter = new FieldEquationFormatter(({ dataset: this.model }))
		this.MAX_TABLE_ROWS = 5
		this.formView.on('change', this._change.bind(this))
	},

	_change: function() {
		// we have to keep track of the attributes this way because on change,
		// the listener in the nav pane will populate the parentId and index
		// properties on the attributes and we need to send those to the server
		_.extend(this.model.attributes,
			{ permissions: this.permissionsPanel.getPermissions() },
			formHelper.readFromDom(this.el))

		this.trigger('change', this.model.attributes)
	},

	render: function({ instadone } = {}) {
		// capture previous state if it exists
		const permissionBy = _.get(this.permissionsPanel, 'permissionBy', 'principal')

		// (re)render everything
		this.removeChildViews()

		var heading = this.model.isNew() ? i18n.get('common.create2', 'datasets.dataset') :
			this.model.get('label')
		this.header = new DatasetsDisplayHeader({
			heading: heading,
			model: this.model,
			subsection: 'edit',
			tabs: tabs({
				id: this.model.id || this.model.get('relativeId'),
				section: 'datasets'
			})
		}).render()

		this.editButtons = new EditButtons({
			section: 'datasets',
			model: this.model,
			strongDeleteMessage: this._createDeleteMessage()
		}).render()

		this.$el.empty().append(this.header.el, template(this.context()))
		this.disableAllowManuallyAddingRecordsIfNeeded()
		this.$('.edit-buttons-container').append(this.editButtons.$el.addClass('edit-buttons-bottom'))
		// copy button is hidden via css (datasets.scss)

		this.$('.dataset-connections, .fields')
			.toggleClass('is-not-displayed', this.model.isNew())
		if (this.model.isNew() || _.isNil(this.model.get('dataSourceMetadata'))) {
			this.$('.change-total-display-container').addClass('is-not-displayed')
		}

		dropdown.idLabels(this.$('[name=databaseId]'), this._databases())

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()
		this.trackedField = new MarkedField({
			el: this.$('[name=tracked]'),
			validator: requiredValidator
		}).render()

		this.renderPermissionsPanel({permissionBy})
		this.renderConnection()
		datasetStatus().then(status => {
			this.listenTo(status, 'change', props => {
				if (props.id !== this.model.id || this.prevProps === props) {
					return
				}
				// If nothing changed, no need to continue. Prevents bubbling. #51555
				this.prevProps = props

				// #34748 display any dataset build error
				this.model.set('errorCode', props.errorCode)
				this.model.set('errorArguments', props.errorArguments)
				this.model.set('stackTrace', props.stackTrace)

				this.renderConnectionErrorMessage()

				if (props.status === Dataset.READY) {
					if (props.numTracked &&
						props.numTracked !== this.model.get('numTracked')) {
						this.model.set('numTracked', props.numTracked)
						this.renderConnectionButtons()
					}

					const datasetConnection = this.model.get('dataSourceMetadata')
					if (!_.isNil(props.numRows)) {
						datasetConnection.numRows = props.numRows
						this.model.set('dataSourceMetadata', datasetConnection)
					}

					// #36556 update the fields to have error messages and re-render them
					if (!_.isNil(props.fieldErrorsById)) {
						const fields = this.model.get('fields')
						_.forEach(fields, field => {
							const fieldError = props.fieldErrorsById[field.id]
							if (fieldError) {
								field.errorMessage = fieldError
								return
							}
							// if the websocket didn't return a field error, then the error is no longer there
							field.errorMessage = null
						})
						this.model.setFields(fields)
					}

					this.renderFields()
					this.renderPrimaryKey()
				}
			})
		})
		this.renderFields()
		this.renderVisibleLinkedFields()

		formHelper.writeToDom(this.model, this.el)

		// AFTER formHelper.writeToDom
		this.renderPrimaryKey()
		// AFTER renderPrimaryKey #14651
		this.secure()

		// #14397 Datasets Edit tab always prompts to save in IE11.  Note
		// process.nextTick doesn't work
		setTimeout(() => {
			this.formView.start({
				isNew: this.model.isNew(),
				instadone
			})

			// This needs to happen after formView has initialized or it will
			// immediately clear the errors
			if (this.model.get('status') == Dataset.ERROR) {
				this.renderConnectionErrorMessage()
			}
		}, 10)

		this._buildCovertTooltips()

		let startingScroll = _.result(this.viewState, 'scrollTop')
		if (startingScroll) {
			scrollContainer(this.el).scrollTop(startingScroll)
		}
		delete this.viewState

		// #31238 it doesn't really ever make sense to display the period
		// selector on the edit tab for datasets
		this.$('.period-display').addClass('is-not-displayed')
		this.on('resize', () => _.invoke(this.permissionsPanel, 'resize'))
		this.toggleEditAllCheckbox()
		return this
	},

	/**
	 * #34748 displays a banner with information about why the dataset failed to build
	 */
	renderConnectionErrorMessage() {
		const errorCode = this.model.get('errorCode')
		if (!errorCode) {
			this.clearConnectionErrorMessage()
			return
		}

		const errorArguments = this.model.get('errorArguments') || []
		this.formView.errorMessage(i18n.highlight(errorCode, ...errorArguments),
			this.model.get('stackTrace'))
	},

	clearConnectionErrorMessage: function() {
		this.formView.clearErrors()
	},

	_createDeleteMessage: function () {
		// #13916 provide a stronger delete confirmation when deleting a dataset
		if (this.model.get('type') === Dataset.DATASET) {
			const substitution = highlight(this.model.get('label'))
			return i18n.get('datasets.deleteConfirmation', substitution)
		}
	},

	context: function() {
		return {
			connectionsNoneMessage: i18n.get('common.thereAreNo', 'datasets.connections'),
			fieldsNoneMessage:  i18n.get('common.thereAreNo', 'datasets.fields')
		}
	},

	disableAllowManuallyAddingRecordsIfNeeded: function() {
		const newAllowed = this.model.get('newAllowed')
		// always allow checking the checkbox if we are not already allowing manual records
		if (!newAllowed) {
			_.invoke(this.newAllowedTooltip, 'remove')
			return
		}

		const hasRecordsManuallyAdded = this.model.get('hasRecordsManuallyAdded')
		if (hasRecordsManuallyAdded > 0) {
			this.$('[name=newAllowed]').attr('disabled', true)
			const newAllowedEl = this.$('.new-allowed')
			newAllowedEl.on('click', () => {
				_.invoke(this.newAllowedTooltip, 'remove')

				this.newAllowedTooltip = new Tooltip({
					attachTo: newAllowedEl,
					content: i18n.get('datasets.records.newAllowed.disabled.recordsAdded'),
					placement: 'below'
				}).render()
			})
		}
	},

	secure: function() {
		var shouldHidePermissions = this.model.shouldHidePermissions()
		if (shouldHidePermissions) {
			// do NOT remove it, or else we won't have the proper permissions
			// saved with the dataset
			this.$('.permissions').addClass('is-not-displayed')
		}
		var otherPanelsHidden = !this.model.isNew() && !this.model.isModifyDataset()
		if (otherPanelsHidden) {
			this.$('.datasets-info, .dataset-connections, .fields, .visible-linked-fields').remove()

			if (!shouldHidePermissions) {
				this.$('.permissions').addClass('is-first-visible-section')
			}
		}
		if (shouldHidePermissions && otherPanelsHidden) {
			let type = this.model.getTypeDescription().toLowerCase()
			let message = i18n.get('common.security.missing.datasets.edit', type)
			let context = { message, hideContactAdminMessage: true }
			this.$('.scroll-container').html(noPermission(context))
			this.$('.edit-buttons').remove()
		}

		let administer = this.model.isModifyDataset()
		this.$('.connection-row .edit, .connection-row .delete').toggleClass('is-not-displayed', !administer)
		// #56867 remove the move and delete buttons if the user doesn't have
		// modify dataset permissions
		if (!administer) {
			this.$('.move-copy, .delete-container').remove()
		}

		// #19898 remove the link to admin if the user doesn't have permission
		// #49251 viewing rollup trees is now based on having app admin permission
		// (see ensureRollupTreePermission methods in DatasetTreesController and
		// RollupTreeGroupsController)
		if (!permissions.appAdmin()) {
			this.$('.rollup-link')
				.removeClass('sp-navigate text-link')
				.removeAttr('href')
				// since the element no longer works as a link, update the cursor
				.css('cursor', 'default')
		}
	},

	renderPrimaryKey: function() {
		let el = this.$('[name=primaryKey]')
		if (!this.model.get('primaryKeyEditable')) {
			el.addClass('disabled')
			el.on('click', () => {
				_.invoke(this.pkTooltip, 'remove')

				this.pkTooltip = new Tooltip({
					attachTo: this.$('.primary-key-select.select'),
					content: i18n.get(this.model.get('primaryKeyLockedExplanation')),
					placement: 'below'
				}).render()
			})
		}

		let metadata = this.model.get('dataSourceMetadata')
		let options = _(this.getPrimaryKeyFields())
			.orderBy((field) => field.intermediateColumnName?.toLocaleUpperCase())
			.map((field) => {
				const primaryKey = metadata.primaryKey
				const value = this.model.hasNoDataSource() ? field.label :
					field.intermediateColumnName
				const valueIsPrimaryKey =
					!_.isNil(value) &&
					!_.isNil(primaryKey) &&
					_.lowerCase(value) === _.lowerCase(primaryKey)
				const selected = primaryKey && valueIsPrimaryKey
				return {
					label: _.escape(field.label),
					value,
					selected
				}
			})
			.value()

		// if the record ID is optional, allow the Record ID column to not be
		// set by adding an empty option
		if (this.model.isRecordIdOptional()) {
			let noPkSelected = _.isEmpty(metadata.primaryKey)
			// add the empty option
			options = [ {
				value: '',
				label:
					`<span class="blank-value">
						${i18n.get('datasets.dataSource.choosePrimaryKey.none')}
					</span>`,
				selected: noPkSelected
			} ].concat(options)
		}
		selects.filtering(el, {
			options,
			escapeLabels: false,
			// #35865 the options are already sorted, so letting the select sort
			// again messes that up
			sort: null
		})

		// mark Record ID Column as required, if appropriate
		if (!this.model.isRecordIdOptional() && !this.pkField) {
			let opts = {el, validator: requiredValidator}
			this.pkField = new MarkedField(opts).render()
		}
	},

	getPrimaryKeyFields: function() {
		if (this.model.hasNoDataSource()) return getValidPrimaryKeyDatasetFields(this.model)

		const metadata = this.model.get('dataSourceMetadata')

		return getValidPrimaryKeyAutomaticAndDatasetFields(this.model, metadata.fields)
	},

	/**
	 * Updates the model with the selected primary key after a field is edited
	 * in case the user changed the name of the field. See #61165
	 */
	updateRecordIdForFieldEdit: function(field) {
		if (!field.primaryKey) return

		// re-render the Record ID dropdown so we can successfully set the new value
		// from the updated options
		this.renderPrimaryKey()

		let recordIdColumnOrFieldLabel
		if (this.model.hasNoDataSource()) {
			// datasets with no data source always use fields instead of source
			// columns since there is no source!
			recordIdColumnOrFieldLabel = field.label
		} else {
			if (field.fieldType === DATASET_FIELD_TYPE.BASIC) {
				recordIdColumnOrFieldLabel = field.columnName
			} else {
				recordIdColumnOrFieldLabel = field.label
			}
		}

		this.$('[name=primaryKey]').val(recordIdColumnOrFieldLabel)
		this.changePrimaryKey()
		this.renderPrimaryKey()
	},

	renderPermissionsPanel: function(options = {}) {
		var permissions = this.model.get('permissions') || []
		// #52873 populate 'principal.rollupPermission' with the value from the
		// permission's filters to provide the  selected value in the permissions-rollup-select
		_.each(permissions, p => {
			if (p.principal.type === Dataset.ROLLUP_TREE_GROUP) {
				const filter = _.find(p.filters, Dataset.isBuiltInFilter)
				this.model.assignBuiltInIsAnyValue(p.principal, filter)
			}
		})
		const {permissionBy} = options
		this.permissionsPanel = new PermissionsPanel({
			model: this.model,
			headingKey: 'admin.group.permissions',
			placeholderKey: 'datasets.addUserGroupOrRTG',
			currentPermissions: permissions,
			permissionBy,
			viewState: _.result(this.viewState, 'permissionsPanel'),
			maxRows: this.MAX_TABLE_ROWS,
			scrollContainer: scrollContainer(this.el)
		})
		this.permissionsPanel.on('change', () => this.formView.change())
		this.$('.permissions').html(this.permissionsPanel.el)
		this.permissionsPanel.render()
		// permissions can't be modified until new fields have been saved
		this.$('.permissions')[0].addEventListener('click', (e) => {
			if (this.$(e.target).hasClass('settings') && this.getFieldAdded()) {
				e.stopPropagation()
				e.preventDefault()
				this.unsavedFieldTooltip && this.unsavedFieldTooltip.remove()
				this.unsavedFieldTooltip = new Tooltip({
					attachTo: e.target,
					content: i18n.get('common.save.saveChanges.required'),
					placement: 'left',
					arrow: 'center'
				}).render()
			}
		}, true)
	},

	renderConnection: function() {
		this.connectionRow = new DatasetConnectionRow({ model: this.model, autoRender: false })
		this.$('.dataset-connections .list').html(this.connectionRow.el)
		this.connectionRow.render()
		this.renderConnectionButtons()

		this.connectionRow.on('render', model => {
			this.model = model
			// don't call row.remove or the connections panel will go away!
			this.connectionRow.undelegateEvents()
			this.connectionRow.stopListening()
			// need to move the buttons back where they belong
			this.renderConnection()
		})

		this.connectionRow.on('resetTooltips', () => this._buildCovertTooltips())

		this.connectionRow.on('change', model => {
			this.model = model
			this.renderFields()
			this.renderPrimaryKey()
		})
	},

	renderConnectionButtons: function() {
		// move the buttons from "row" into the panel-header
		this.$('.dataset-connections.panel .right-buttons').html(this.connectionRow.$('.list-item-actions'))
		// make the row aware of the entire panel so that the buttons still
		// work
		this.connectionRow.setElement(this.$('.dataset-connections.panel'))

		// #14527 disallow deleting spreadsheets (you can always upload a new
		// one)
		if (this.model.isSpreadsheet()) {
			this.$('.dataset-connections .delete').remove()
		}

		// there shouldn't be an edit button for the overall dataset because
		// we're already on the datasets tab
		this.$('.main-actions .edit').remove()
	},

	_buildCovertTooltips: function() {
		this.covertButtonTooltips && this.covertButtonTooltips.cleanup()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
	},

	renderFields: function() {
		let self = this
		// show appropriate display when there are no fields
		const noFields = _.isEmpty(this.model.getDisplayableFields())
		this.$('.fields .table').toggleClass('is-not-displayed', noFields)
		this.$('.fields .min-height-vertical-center').toggleClass('is-not-displayed', !noFields)

		var DatasetsEditFieldAndGroupRenderer = FieldAndGroupRenderer.extend({
			/**
			 * Renders the Fields panel on the Datasets Edit screen
			 *
			 * @constructs
			 *
			 * @param {Object} options
			 *
			 * @param {Dataset} options.model the dataset
			 */
			initialize: function(options = {}) {
				FieldAndGroupRenderer.prototype.initialize.apply(this, arguments)
				this.editableFieldChecker = new EditableFieldChecker({ dataset: this.model })
				this.fieldIndex = 0
			},
			getGroupHtml(group) {
				return fieldGroupRow({ group })
			},
			_getEquation(field) {
				switch (field.fieldType) {
					case 'basic': return _.trim(field.equation, '[ ]')
					case 'calculated': return field.equation
					case 'cluster': {
						const clusterCount = field.numClusters
						return i18n.countMessage('datasets.field.clusterFields.count',
							clusterCount)
					}
					case 'manual': return ''
					default: {
						console.warn(`Unsupported field type ${field.fieldType}`)
						return ''
					}
				}
			},
			getFieldsHtml(fields) {
				var html = ''
				fields = _.filter(fields, field => {
					// only filter fields that have an id so unsaved fields still show up
					if (field.id) {
						return !this.model.isManuallyAddedFieldId(field.id)
					}
					return true
				})
				_.each(fields, (field, i) => {
					this.trigger('field', field, this.fieldIndex++)
					var ranges = null
					if (isNumericDataType(field.dataType) || field.dataType === TEXT) {
						ranges = _.size(field.ranges)
						ranges = ranges > 0 ? ranges : 0
					}
					var maxRange = ranges >= 2 ? 2 : ranges
					var rangesKey = rangesLabel[maxRange]
					if (!_.isNil(rangesKey)) {
						rangesKey += rangeKeySuffix(field.dataType)
					}
					let sourceIcon = 'generic'
					if (field.fieldType === 'calculated') {
						sourceIcon = 'calculated'
					}
					if (field.fieldType === CLUSTER) {
						sourceIcon = CLUSTER
					}
					const isNotEditableField = this.editableFieldChecker.isNotEditableField(field)
					const { editable, disabled } = this.editableFieldChecker.getDefaultEditableAndEditableDisabled(field)
					let disabledMsgCode
					if (disabled) {
						disabledMsgCode = this.editableFieldChecker.getMessageCodeForDisabledEditable(field)
					}
					var context = {
						// Add a field id to the markup so that we can identify it
						// if we need to scroll to it. Newly added fields which aren't
						// yet saved and don't have an id are given a temporary
						// 'unsaved-<unsavedFieldId>' id.
						id: _.isNil(field.unsavedFieldId) ? field.id : 'unsaved-' + field.unsavedFieldId,
						label: field.label,
						equation: this._getEquation(field),
						dataTypeText: self.getDataTypeText(field),
						linkedDatasetId: field.linkedDatasetId,
						// #15209 only use the tree ID if this is a rollup field
						treeId: field.dataType === ROLLUP ? field.treeId : undefined,
						editable,
						disabled,
						disabledMsgCode,
						isNotEditableField,
						hideFromNonAdmins: field.hideFromNonAdmins,
						rangesLabel: i18n.get(rangesKey, ranges),
						primaryKey: field.primaryKey,
						errorMessage: field.errorMessage,
						isStriped: i%2 > 0,// Keep striped rows consistent given the .table-body-subheader's
						sourceIcon,
						fieldType: field.fieldType
					}
					html += fieldRow(context)
				})
				return html
			}
		})

		var pkIndex
		var errorFieldIndexes = []
		var renderer = new DatasetsEditFieldAndGroupRenderer({ model: this.model })
		this.fields = []
		renderer.on('field', (field, index) => {
			this.fields.push(field)

			if (field.primaryKey) {
				pkIndex = index
			}

			if (field.errorMessage) {
				errorFieldIndexes.push(index)
			}
		})

		this.$('.fields .table tbody').remove()
		this.$('.fields .table').append(renderer.getHtml())

		// #45149 disable the delete button if there's only one field and records have been added
		if (!this.deleteFieldAllowed()) {
			const deleteButtonEl = this.$('.field-row .table-actions-cell .delete.button')
			deleteButtonEl.addClass('is-disabled')
			deleteButtonEl.on('click', () => {
				_.invoke(this.deleteButtonTooltip, 'remove')

				this.deleteButtonTooltip = new Tooltip({
					attachTo: deleteButtonEl,
					content: i18n.get('datasets.fields.delete.disabled.recordsAdded'),
					placement: 'below'
				}).render()
			})
		}

		// #11593 don't allow deleting the primary key
		this.$('.fields tbody tr.field-row').eq(pkIndex).find('.delete').closest('li').addClass('is-not-displayed')

		// render field errors
		this.errorFieldTooltip = new TooltipAndDetails({
			el: this.el,
			selector: '.error-indicator',
			tooltipContent: (e) => {
				return errorIndicatorTooltip({
					message: this._field(e).errorMessage,
					showDetailsLink: deviceType.touchOnly
				})
			},
			details: (e) => {
				const field = this._field(e)
				const url = `${this.model.getFieldErrorsUrl()}?${$.param({
					fieldId: field.id
				})}`
				return $.get(url).then(fieldErrors => {
					if (fieldErrors.length > 0) {
						const metadata = this.model.get('dataSourceMetadata')
						return new DatasetFieldErrorView({
							fieldName: field.label,
							fieldErrors,
							pkColumnName: metadata.primaryKey,
							isSpreadsheet: this.model.isSpreadsheet()
						})
					}

					return new ErrorView({
						message: field.errorMessage,
						stackTrace: field.stackTrace
					})
				})
			},
			tooltipOptions: {
				extraClass: 'tooltip-and-details non-abbreviated-tooltip details-only'
			}
		})

		// Setup the fields table for expanding/collapsing
		this.fieldsDatasetTableExpander && this.fieldsDatasetTableExpander.remove()
		this.fieldsDatasetTableExpander = new DatasetsTableExpander({
			table: this.$('.fields table'),
			isCollapsed: _.result(this.viewState, 'fields.tableCollapsed'),
			maxRows: this.MAX_TABLE_ROWS,
			scrollContainer: scrollContainer(this.el)
		}).setup()

		this.setUpGeographicDeleteTooltips()
		this.toggleEditableColumnCheckboxes(this.$('.editable-column'))
	},

	// #54116
	toggleEditAllCheckbox: function() {
		let editableFieldChecker = new EditableFieldChecker({ dataset: this.model })
		// disable edit if dataset requires record id
		let disabled = !editableFieldChecker.editableAllowed()

		this.$('.toggle-all [type=checkbox]').attr('disabled', disabled)
		const el = this.$('.toggle-all')
		if (disabled) {
			el.on('click', () => {
				_.invoke(this.editCheckboxTooltip, 'remove')

				this.editCheckboxTooltip = new Tooltip({
					attachTo: this.$('.toggle-all label'),
					content: i18n.get('datasets.fields.editable.primaryKeyRequired'),
					placement: 'above',
					arrow: 'left'
				}).render()
			})
		}
	},

	/*
	 * A bug prevents the the handlebars template from reliably applying the
	 * correct checked status between saves so handle it here. #51551
	 */
	toggleEditableColumnCheckboxes: function(columns) {
		_.forEach(columns, td => {
			let input = this.$(td).find('input')
			let checked = input.data('checked')
			input.prop('checked', checked)
		})
		this.toggleAllCheckboxState()
		this.toggleEditAllCheckbox()
	},

	toggleAllCheckboxState: function() {
		// If all checkboxes are checked, check the toggle-all input
		// If at leat one is not, uncheck it.
		let checked = this.$('.editable-column input:not(:checked)')?.length < 1
		this.$('.toggle-all [type=checkbox]').prop('checked', checked)
	},

	onClickDisabledCheckboxTooltip: function(e) {
		let label = this.$(e.currentTarget).closest('label')
		let message = i18n.get(label.data('msg'))
		new Tooltip({
			attachTo: label,
			content: message,
			placement: 'above',
			arrow: 'left'
		}).render()
	},

	renderVisibleLinkedFields: function() {
		// toggle visibility based on presence of linked datasets
		this.$('.visible-linked-fields').toggleClass('is-not-displayed',
			_.isEmpty(this.model.get('linkedDatasets')))

		let sorted = _.sortBy(this.model.get('visibleLinkedFields'), f =>
			f.label.toLocaleLowerCase())
		// render previously selected visible linked fields
		let html = _(sorted)
			.map(this.visibleLinkedFieldHtml.bind(this))
			.reduce((allHtml, fieldHtml) => allHtml += fieldHtml)
		this.$('.visible-linked-fields tbody').append(html)
		_.each(this.$('.visible-linked-fields tbody tr'), (row, i) => {
			this.$(row).data('visibleLinkedField', sorted[i])
		})

		this.setupLinkedDatasetInfoTooltips()
		this.toggleVisibleLinkedFieldsTable()
	},

	toggleVisibleLinkedFieldsTable: function() {
		let table = this.$('.visible-linked-fields table')
		let hasFields = table.find('tbody tr:not(.collapse-row)').length > 0
		table.toggleClass('is-not-displayed', !hasFields)
		this.$('.visible-linked-fields .min-height-vertical-center').toggleClass('is-not-displayed', hasFields)

		if (table.find('tr').length <= this.MAX_TABLE_ROWS) {
			table.removeClass('is-expanded')
		}

		this.visibleLinkedDatasetTableExpander && this.visibleLinkedDatasetTableExpander.remove()
		this.visibleLinkedDatasetTableExpander = new DatasetsTableExpander({
			table,
			isCollapsed: _.result(this.viewState, 'visibleLinked.tableCollapsed'),
			maxRows: this.MAX_TABLE_ROWS,
			scrollContainer: scrollContainer(this.el)
		}).setup()
	},

	setupLinkedDatasetInfoTooltips: function() {
		if (this.model.get('allUniquePaths')) {
			// don't show the tooltips if there are only unique paths to all of
			// the datasets
			this.$('.visible-linked-fields .info.button')
				.addClass('is-not-displayed')
		} else {
			_.invoke(this.linkedDatasetInfoTooltips, 'remove')
			this.linkedDatasetInfoTooltips = new TooltipAndDetails({
				el: this.$('.visible-linked-fields'),
				selector: '.info.button',
				tooltipContent: (e) => {
					let visibleLinkedField = this.getVisibleLinkedField(e)
					let datasetsAndFields = datasetPaths.datasetsAndFields(
						this.model, visibleLinkedField.path)
					return new Breadcrumbs({
						title: i18n.get('datasets.linked.pathToDataset'),
						objects: datasetsAndFields
					}).render()
				},
				tooltipOptions: {
					extraClass: 'linked-info-tooltip'
				}
			})
		}
	},

	visibleLinkedFieldHtml: function(visibleLinkedField) {
		// the linkedDatasetId is populated on new fields
		let linkedDatasetId = visibleLinkedField.linkedDatasetId ||
			// for existing fields, need to read from the path
			datasetPaths.lastDatasetId(visibleLinkedField.path)
		let field = this.model.getFieldByFieldIdentifier(
			visibleLinkedField.fieldId, linkedDatasetId)
		return visibleLinkedFieldRow({
			id: visibleLinkedField.id,
			label: visibleLinkedField.label,
			dataset: unwrapModel(this.model.datasetsById[linkedDatasetId]),
			dataTypeText: this.getDataTypeText(field),
			field,
			treeId: field.dataType === ROLLUP ? field.treeId : undefined,
			visibleLinkedField: linkedDatasetId
		})
	},

	// Open the given fields table and scroll to selected field
	_showTableRow: function(table, selector) {
		table.toggleExpandTable(true)
		let newFieldRow = table.getRow(selector)
		table.scrollIntoView(newFieldRow, this.$('.display-pane-header').height())
	},

	onAddVisibleLinkedField: function() {
		// #41432 load all shortest paths to linked datasets before displaying the dialog
		const xhr = $.get(`/api/datasets/${this.model.id}/shortestpaths`)
		appDisplay.dialog(xhr, shortestPathsByDatasetId => {
			const form = new VisibleLinkedFieldForm({
				model: this.model,
				add: true,
				shortestPathsByDatasetId
			})
			form.on('done', visibleLinkedField => {
				let visibleLinkedFields = this.model.get('visibleLinkedFields')
				visibleLinkedFields = visibleLinkedFields || []
				visibleLinkedFields.push(visibleLinkedField)
				this.model.set('visibleLinkedFields', visibleLinkedFields)
				this.model.updateVisibleLinkedFieldsById()
				let html = this.visibleLinkedFieldHtml(visibleLinkedField)
				this.$('.visible-linked-fields tbody').append(html)
				this.$('.visible-linked-fields tr:last').data('visibleLinkedField',
					visibleLinkedField)
				this.formView.change()
				this.setupLinkedDatasetInfoTooltips()
				this.toggleVisibleLinkedFieldsTable()
				this._showTableRow(this.visibleLinkedDatasetTableExpander, `[data-id=${visibleLinkedField.id}]`)
			})
			return form
		})
	},

	/*
	 * Toggles checked status for all edit field checkboxes at once
	 * if they aren't disabled.
	 */
	toggleAllEditableCheckboxes: function(e) {
		let isChecked = this.$(e.target).is(':checked')
		this.$('.editable-column [name=editable]:not(:disabled)')
			.prop('checked', isChecked)
			.trigger('change')
	},

	/* Update the model so the chosen state can be saved. This also makes it so
	 * the field-form will stay in sync with the datasets-edit view.
	 */
	setFieldEditableState: function(e) {
		let target = this.$(e.target)
		let id = target.closest('tr').data('field-id')
		let fieldIndex = _.findIndex(this.model.attributes.fields, ['id', id])
		let isEditable = target.is(':checked')
		_.set(this.model.attributes, `fields[${fieldIndex}].editable`, isEditable)
		this.toggleAllCheckboxState()
		this.toggleEditAllCheckbox()
	},

	/**
	 * Returns the visible linked field related to the given event
	 */
	getVisibleLinkedField: function(e) {
		return this.$(e.target).closest('tr')
			.data('visibleLinkedField')
	},

	onEditVisibleLinkedField: function(e) {
		let visibleLinkedField = this.getVisibleLinkedField(e)
		// #41432 #54738 load all shortest paths to linked datasets before
		// displaying the dialog
		const xhr = $.get(`/api/datasets/${this.model.id}/shortestpaths`)
		appDisplay.dialog(xhr, shortestPathsByDatasetId => {
			let form = new VisibleLinkedFieldForm({
				model: this.model,
				visibleLinkedField,
				shortestPathsByDatasetId
			})
			form.on('done', newVisibleLinkedField => {
				_.extend(visibleLinkedField, newVisibleLinkedField)
				this.model.updateVisibleLinkedFieldsById()
				this.$(e.target).closest('tr')
					.replaceWith(this.visibleLinkedFieldHtml(visibleLinkedField))
				this.$(`tr[data-id="${visibleLinkedField.id}"`)
					.data('visibleLinkedField', visibleLinkedField)
				this.formView.change()
				this.setupLinkedDatasetInfoTooltips()
			})
			return form
		})
	},

	onDeleteVisibleLinkedField: function(e) {
		const vlfItem$ = this.$(e.target).closest('[data-id]')
		const { id: vlfId, fieldId } = vlfItem$.data()
		this.$(e.target).closest('tr').remove()
		_.remove(this.model.get('visibleLinkedFields'), visibleLinkedField => {
			// #33383 for unsaved vlfs we delete them by their fieldId, since they don't have a vlfId yet
			if (typeof vlfId === 'string' && vlfId.startsWith('unsaved')) {
				const vlfFieldId = visibleLinkedField.fieldId
				return vlfFieldId == fieldId
			}
			// for previously saved vlfs, delete them by their vlfId
			return visibleLinkedField.id == vlfId
		})
		this.formView.change()
		this.toggleVisibleLinkedFieldsTable()
	},

	getDataTypeText: function(field) {
		field = unwrapModel(field)
		let key = dataTypeKey(field.dataType)
		let linkedDatasetLabel = ''
		if (field.dataType == DATASET_LINK) {
			let linkedDataset = _.find(this.model.get('linkedDatasets'),
				linkedDataset => linkedDataset.id == field.linkedDatasetId)
			// if we just setup the link, we won't have the linked
			// dataset which is fine.  The text will just say "Dataset Link"
			// instead of "Dataset link to {0}"
			if (linkedDataset != null) {
				linkedDatasetLabel = linkedDataset.label
				key = 'datasets.datatype.link.withArg'
			}
		} else {
			// linkedDatasetId doesn't get updated until the changes are saved,
			// so we'll manually remove the ID until then.
			field.linkedDatasetId = undefined
		}
		return i18n.get(key, linkedDatasetLabel)
	},

	changePrimaryKey: function() {
		this.secure()

		// #15425 don't mess around with the primary key if it's not editable
		if (!this.model.get('primaryKeyEditable')) {
			return
		}

		let primaryKey = this.$('[name=primaryKey]').val()
		primaryKey = getIntermediateTableColumnName(primaryKey)
		let metadata = this.model.get('dataSourceMetadata')
		if (metadata) {
			metadata.primaryKey = primaryKey
		}

		// make sure no other field is chosen as primary key
		_.each(this.model.get('fields'), (field) => {
			field.primaryKey = false
		})

		const pkField = this.getFieldForPrimaryKey(primaryKey)


		let pkFieldId = pkField ? pkField.id : undefined
		this.model.set('primaryKeyFieldId', pkFieldId)
		if (pkField) {
			pkField.primaryKey = true
			this.renderFields()
		} else if (primaryKey) {
			this.addPrimaryKey(primaryKey)
		}
	},

	/**
	 * @param primaryKey {string}
	 * @returns {DatasetField}
	 */
	getFieldForPrimaryKey: function(primaryKey) {
		// if this is a dataset without a data source, match the PK by the field
		// label instead of by equation
		const primaryKeyDatasetFields = getValidPrimaryKeyDatasetFields(this.model)
		if (this.model.hasNoDataSource()) {
			// #61165 need to use the raw value of the field for sourceless datasets
			// instead of the column name since there's no source data to have columns!
			primaryKey = this.$('[name=primaryKey]').val()
			return _.find(primaryKeyDatasetFields, field =>
				field.label === primaryKey)
		}

		let pkField
		// first try to find the field by the intermediate table column
		pkField = this.model.getBasicFieldsByIntermediateTableColumn()[primaryKey]

		if (_.isNil(pkField)) {
			// if the field wasn't found by the intermediate table column, try
			// finding it by its equation
			const possiblePkFields = _.filter(primaryKeyDatasetFields,
				field => {
					const column =
						getIntermediateTableColumnFromBasicEquation(field.equation)
					return column === primaryKey
				})

			// #57295 we want the "one true" field for this column, which would be
			// the basic field with the same intermediate column as its equation
			pkField = _.find(possiblePkFields, field => {
				field.fieldType = DATASET_FIELD_TYPE.BASIC
			})

			// if we still don't have a PK field, fall back to a single field calculated field
			if (_.isNil(pkField) && possiblePkFields.length === 1) {
				pkField = possiblePkFields[0]
			}
		}

		return pkField
	},

	// returns the ids and labels of databases that can appear in the
	// "Store local data in" dropdown
	_databases: function() {
		return _.filter(databases.get(), function(database) {
			if (database.type === 'scoreboard' &&
				database.id == globals.databaseId) {
				return true
			}
			return database.type === Dataset.DATASET
		})
	},

	addPrimaryKey: function(primaryKey, options) {
		if (_.isEmpty(primaryKey)) {
			return
		}

		// make sure no other field is chosen as primary key
		_.each(this.model.get('fields'), (field) => {
			field.primaryKey = false
		})

		let metadata = this.model.get('dataSourceMetadata')
		const equation = this.fieldEquationFormatter.format({
			datasetId: this.model.id,
			connectionId: metadata.id,
			columnOrField: primaryKey
		})

		this.model.attributes.fields = this.model.attributes.fields || {}
		this.model.attributes.fields.push(_.extend({
			dataType: TEXT,
			editable: false,
			label: primaryKey,
			equation: equation,
			primaryKey: true,
			fieldType: DATASET_FIELD_TYPE.BASIC
		}, options))

		this.renderFields()
	},

	addField: function(e) {
		this._fieldWizard(e).on('done', field => this._onAddFieldWizardDone(field))
	},

	/**
	 * @param {DatasetField} field
	 */
	_onAddFieldWizardDone: function(field) {
		this.model.attributes.fields.push(field)

		// Apply temporary id's to the fields that aren't saved yet.
		// Start at -1 since we anticipate there being at least 1 new
		// field bc one was just added in this form.
		let tempId = -1
		_.each(this.model.attributes.fields, f => {
			if (_.isNil(f.id)) {
				tempId++
				f.unsavedFieldId = tempId
			}
		})

		// make sure this.model.fields is updated
		this.model.trigger('change:fields')
		this.renderFields()
		this._showTableRow(this.fieldsDatasetTableExpander, `[data-field-id=unsaved-${tempId}]`)
		this.formView.change()
	},

	editField: function(e) {
		this._fieldWizard(e).on('done', field => this.onEditFieldDone(field))
	},

	onEditFieldDone: function(field, e = {}) {
		this._updateField(this._fieldIndex(e), field)
		const fields = this.model.get('fields')
		const fieldIndex = _.findIndex(fields, ['id', field.id])
		// #58374 update the field in the original model, so that we can check for
		// circular references when validating other fields in the field editor
		// without saving the whole dataset in between editing each field
		fields[fieldIndex] = field
		this.updateRecordIdForFieldEdit(field)
		this.model.set('fields', fields)
		this.model.combinedFieldsById[field.id] = field
	},

	_fieldWizard: function(e) {
		let wizard = new FieldWizard(this._getBaseEditFieldOptions(e))
		wizard.start({ xhr: this._getAddEditFieldXhr(e) })
		return wizard
	},

	editFieldRange: function(e) {
		const form = new CategoriesAndRangesForm(this._getBaseEditFieldOptions(e))
		const index = this._fieldIndex(e)
		form.on('done', field => this._updateField(index, field))
		appDisplay.dialog(form)
	},

	_getAddEditFieldXhr: function(e) {
		const baseFieldOpts = this._getBaseEditFieldOptions(e)
		const locationTreeNodeId = _.get(baseFieldOpts, 'field.locationTreeNodeId')
		return $.get('api/datasets/metadata', { locationTreeNodeId })
	},

	_getBaseEditFieldOptions: function(e) {
		const field = this._field(e) ?? {}
		const originalField = this.originalModel?.combinedFieldsById[field?.id]
		return {
			model: this.model,
			originalField,
			field,
			primaryKey: this.getPrimaryKey()
		}
	},

	_updateField: function(index, updatedField) {
		this.fields[index] = updatedField
		const isUnsavedField = !_.isNil(updatedField.unsavedFieldId)
		const keyByProperty = isUnsavedField ? 'unsavedFieldId' : 'id'
		const modelFields = this.model.get('fields') || []
		const modelFieldsById = _.keyBy(modelFields, keyByProperty)
		delete modelFieldsById[undefined]
		const updatedFieldId = _.get(updatedField, keyByProperty)
		const existingField = modelFieldsById[updatedFieldId]
		if (!_.isNil(existingField)) {
			_.remove(modelFields, existingField)
		}
		modelFields.push(updatedField)
		this.model.set('fields', modelFields)

		this.renderFields()
		this.formView.change()
	},

	getPrimaryKey: function() {
		if (this.model.attributes.primaryKeyEditable) {
			return this.$('[name=primaryKey]').val()
		} else {
			return this.model.attributes.dataSourceMetadata.primaryKey
		}
	},

	deleteFieldAllowed: function() {
		const hasRecordsManuallyAdded = this.model.get('hasRecordsManuallyAdded')
		const onlyOneField = _.get(this.fields, 'length') === 1
		return !(onlyOneField && !!hasRecordsManuallyAdded)
	},


	setUpGeographicDeleteTooltips: function() {
		_.invokeMap(this.deleteGeographicFieldTooltips, 'remove')
		this.deleteGeographicFieldTooltips = []
		_.each(this.fields, field => {
			if (isGeographicDataType(field.dataType)) {
				if (!deleteGeographicFieldAllowed(field, this.fields)) {
					let content = geographicFieldDependencyMessage(field, this.fields)
					let deleteGeoButtonEl = this.$(`.fields tbody tr.field-row[data-field-id=${field.id}] .table-actions-cell .delete.button`)
					deleteGeoButtonEl.addClass('is-disabled')
					deleteGeoButtonEl.on('click', () => {
						this.deleteGeographicFieldTooltips.push(new Tooltip({
							attachTo: deleteGeoButtonEl,
							content,
							placement: 'below'
						}).render())
					})
				}
			}
		})
	},

	deleteField: function(e) {
		if (!this.deleteFieldAllowed()) return

		var field = this._field(e)

		if (!deleteGeographicFieldAllowed(field, this.fields)) return

		_.remove(this.model.attributes.fields, (f) => field === f)
		// make sure this.model.fields is updated
		this.model.trigger('change:fields')
		this.renderFields()
		this.formView.change()
	},

	_fieldIndex: function(e) {
		let el = e.target || e
		let row = this.$(el).closest('tr')
		return this.$('.field-row').index(row)
	},

	_field: function(e) {
		var index = this._fieldIndex(e)
		return this.fields[index]
	},

	editFieldGroup: function(e) {
		let view = new FieldGroupForm({
			model: this.model,
			group: this._fieldGroup(e)
		})
		appDisplay.dialog(view)
		view.on('done', () => {
			this.renderFields()
			this.formView.change()
		})
	},

	deleteFieldGroup: function(e) {
		let fieldGroup = this._fieldGroup(e)
		var confirmation = new DeleteConfirmation({
			label: fieldGroup
		})
		appDisplay.dialog(confirmation)
		// the banner says the action can't be undone, but this isn't a very
		// destructive operation
		confirmation.$('.banner').remove()
		confirmation.on('confirm', () => {
			let fields = this.model.getFieldsForGroup(fieldGroup)
			_.each(fields, (field) => delete field.group)
			this.formView.change()
			this.renderFields()
			confirmation.trigger('done')
		})
	},

	/**
	 * Returns the field group relevant to a DOM event
	 */
	_fieldGroup: function(e) {
		return this.$(e.target).closest('tr').text().trim()
	},

	changeTotalDisplay: function() {
		var view = new ChangeTotalDisplay({
			model: this.model,
			aggregationFieldId: this.model.get('aggregationFieldId'),
			aggregationType: this.model.get('aggregationType'),
			aggregationVisibleLinkedFieldId: this.model.get('aggregationVisibleLinkedFieldId'),
			filterThroughLocalDataset: this.model.get('filterThroughLocalDataset')
		})
		appDisplay.dialog(view)

		view.on('done', this.formView.change.bind(this.formView))
	},

	/**
	 * Returns true if there's an unsaved field.
	 */
	getFieldAdded() {
		return !!_.find(this.model.get('fields'), field => _.isNil(field.id))
	},

	cancel: function() {
		if (this.model.isNew()) {
			if (conductor.id()) {
				conductor.edit()
			}
		} else {
			this.viewState = this.getViewState()
			this.removeChildViews()
			this.model = this.originalModel.cloneDeep()
			this.render()
		}
	},

	validate: function() {
		var err = FormView.prototype.validate.apply(this.formView, arguments)
		if (err) {
			// Reset the error banner in favor of displaying the errors presented here
			this.clearConnectionErrorMessage()
			return err
		}

		// validate that no fields that are marked for deletion are referenced
		// by security filters
		let permissions = this.permissionsPanel.getPermissions()
		let fields = []
		let principals = []
		_.each(permissions, (permission) => {
			_.each(permission.filters, (filter) => {
				let field = this.model.combinedFieldsById[filter.fieldId]
				if (!field) {
					let originalField = this.originalModel.combinedFieldsById[filter.fieldId]
					if (_.indexOf(fields, originalField) == -1) {
						fields.push(originalField)
					}
					principals.push(permission.principal)
				}
			})
		})

		if (!_.isEmpty(fields)) {
			this.formView.errorMessage(i18n.get('datasets.fields.deleteNotAllowed.permissions'))
			var html = '<ul>'
			_.each(fields, (field) => {
				html += `<li>${_.escape(field.label)}</li>`
			})
			html += '</ul>' +
				`<p>${i18n.get('datasets.fields.deleteNotAllowed.permissions2')}</p>` +
				'<ul>'
			_.each(principals, (principal) => {
				html += `<li>${_.escape(principal.label)}</li>`
			})
			html += '</ul>'
			this.$('.banner-error')
				.addClass('has-multiple-errors')
				.append(html)

			// Reset the error banner in favor of displaying the errors presented here
			this.clearConnectionErrorMessage()

			// return true to indicate there was an error
			return true
		}
	},

	getViewState: function() {
		return {
			fields: {
				tableCollapsed: !this.$('.fields table').hasClass('is-expanded')
			},
			visibleLinked: {
				tableCollapsed: !this.$('.visible-linked-fields table').hasClass('is-expanded')
			},
			scrollTop: scrollContainer(this.el).scrollTop(),
			permissionsPanel: this.permissionsPanel.getViewState()
		}
	},

	submit: function() {
		var data = _.extend({}, this.model.attributes, formHelper.readFromDom(this.el))
		data.permissions = this.permissionsPanel.getPermissions()
		this.save(data)
	},

	_saveModel: function (data, event) {
		// Save the collapsed state of the all the panels on this view and all
		// child views of this view so that it can be rebuilt like it was after
		// a save/cancel is made.
		this.viewState = this.getViewState()

		return this.model.save(data, {
			success: function (model) {
				this.$('.move, .copy, .delete').prop('disabled', false)

				this.formView.start({
					isNew: this.model.isNew()
				})
				this.trigger('save', model, this.model)
				triggerAddOrEdit(event, model, this.originalModel)
				this.originalModel = this.model.cloneDeep()
				// Need the model to be updated before we can re-render
				// (became evident with rollup permission selects)
				this.model.once('sync', () => this.render({ instadone: true }))
			}.bind(this),
			error: function(model, response, options) {
				if (_.has(response.responseJSON, 'actionFailedReason')) {
					let title = i18n.get('common.error.cannotDelete',
						'datasets.dataset.fields')
					appDisplay.dialog(new DependenciesPreventActionView({
						title: response.responseJSON.title || title,
						model: this.model,
						response: response.responseJSON,
						useIcon: true
					}))
					this.formView._setSubmitting(false)
					// #19352 disable the save button since additional changes
					// will be necessary before the form can be saved.  The
					// cancel button remains available in case the user changes
					// their mind
					this.formView.primaryButton.disable()
				} else {
					this.formView.error(response)
				}
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.covertButtonTooltips,
			this.errorFieldTooltip, this.visibleLinkedDatasetTableExpander,
			this.fieldsDatasetTableExpander, this.editableFieldChecker], 'remove')
		this.removeChildViews()
	},

	removeChildViews: function() {
		_.invokeMap([this.header, this.editButtons, this.permissionsPanel,
		 	this.labelField, this.trackedField, this.tooltip,
			this.newNotAllowedTooltip, this.unsavedFieldTooltip, this.pkField,
			this.linkedDatasetInfoTooltips, this.pkTooltip,
			this.deleteGeographicFieldTooltips, this.editCheckboxTooltip], 'remove')
	}

})

export default DatasetsEdit

DatasetsEdit.__filename__ = 'datasets/edit/datasets-edit.js'
